import { INITIAL_COLOR } from "../constants/initialColor";

/**
 * Utility to get a color based on the initial of a name
 */
export const getInitialColor = () => {
  // Create letter-to-index mapping (A=0, B=1, etc.)
  const letterMap: Record<string, number> = {};
  for (let i = 0; i < 26; i++) {
    const letter = String.fromCharCode(65 + i); // A-Z
    letterMap[letter] = i;
  }

  /**
   * Get color for a name based on its initial
   * @param name - Name to get color for
   * @returns The corresponding color from INITIAL_COLOR array
   */
  const getColorForName = (name: string): string => {
    if (!name || typeof name !== "string") {
      return INITIAL_COLOR[0]; // Default to first color
    }

    const initial = name.trim().charAt(0).toUpperCase();
    const index = letterMap[initial];

    // If initial is not a letter A-Z, return first color
    if (index === undefined) {
      return INITIAL_COLOR[0];
    }

    // Map the index to color array with modulo to handle cycling
    const colorIndex = index % INITIAL_COLOR.length;
    return INITIAL_COLOR[colorIndex];
  };

  return {
    getColorForName,
  };
};
